import { Header as PageHeader } from '@web/components/page-components/Header'
import { type Header as HeaderProps } from '@web/graphql-types'
import { usePageStore } from 'apps/fe-donation/libs/hooks/usePageStore'
import Link from 'next/link'
import { useSearchParams } from 'next/navigation'
import { useMemo } from 'react'

const Header = (props: HeaderProps & { isFullWidth?: boolean }) => {
  const currentUrl = usePageStore((state) => state.currentUrl)
  const campaignDomain = usePageStore((state) => state.campaignDomain)
  const searchParams = useSearchParams()
  const isTestMode = usePageStore((state) => !state.isLiveMode)

  const links = useMemo(() => {
    if (!campaignDomain) {
      return []
    }

    const hasParams = !!searchParams?.toString()

    return props.styles?.links?.map((link) => {
      if (link.url.startsWith('http')) {
        return { ...link, url: `${link.url}${hasParams ? `?${searchParams!.toString()}` : ''}` }
      }

      return {
        ...link,
        url: `${campaignDomain}${link.url.startsWith('/') ? `${link.url}` : `/${link.url}`}${hasParams ? `?${searchParams!.toString()}` : ''}`,
      }
    })
  }, [campaignDomain])

  const logoHrefWithParams = useMemo(() => {
    if (!props.styles?.logoHref) {
      return undefined
    }

    const hasParams = !!searchParams?.toString()
    if (props.styles.logoHref.startsWith('http')) {
      return `${props.styles.logoHref}${hasParams ? `?${searchParams!.toString()}` : ''}`
    }

    return `${campaignDomain}${props.styles.logoHref.startsWith('/') ? props.styles.logoHref : `/${props.styles.logoHref}`}${
      hasParams ? `?${searchParams!.toString()}` : ''
    }`
  }, [campaignDomain, props.styles?.logoHref])

  return (
    <PageHeader
      {...props}
      currentUrl={currentUrl}
      styles={{ ...props.styles, links, logoHref: logoHrefWithParams }}
      topOffset={isTestMode ? 36 : 0}
      LinkComponent={Link}
    />
  )
}

export default Header
